import script from "./PatientHomeMonitoringActionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientHomeMonitoringActionModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__